const urlParams = new URLSearchParams(window.location.search);

// Extract the token from the query parameters
const token = urlParams.get("token");
// console.log(token); // Logs the token value correctly

// const token = "4216|2gfcYnvfIV5K4YMe5DVGKQAArD7x81I6c1Z7B9AL88471619";
export const mostCharger = async () => {
  try {
    const response = await fetch(
      "https://2opstarchat.com/api/charge-events/most-charger",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};
